exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__ConfirmationScreen__security-code-field.DS__ConfirmationScreen__security-code-field {\r\n    margin-top: 24px;\r\n}\r\n\r\n.DS__ConfirmationScreen__title.DS__ConfirmationScreen__title {\r\n    font-weight: 600;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.DS__ConfirmationScreen__action-buttons,\r\n.DS__ConfirmationScreen__confirmation-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.DS__ConfirmationScreen__action-buttons {\r\n    margin-top: 72px;\r\n}\r\n\r\n.DS__ConfirmationScreen__action-buttons > .DS__ConfirmationScreen__button + .DS__ConfirmationScreen__button {\r\n    margin-top: 12px;\r\n}\r\n\r\n.DS__ConfirmationScreen__text-button.DS__ConfirmationScreen__text-button {\r\n    text-align: center;\r\n}\r\n\r\n.DS__ConfirmationScreen__cursor.DS__ConfirmationScreen__cursor {\r\n    cursor: pointer;\r\n\r\n}", ""]);

// exports
exports.locals = {
	"security-code-field": "DS__ConfirmationScreen__security-code-field",
	"title": "DS__ConfirmationScreen__title",
	"action-buttons": "DS__ConfirmationScreen__action-buttons",
	"confirmation-wrapper": "DS__ConfirmationScreen__confirmation-wrapper",
	"button": "DS__ConfirmationScreen__button",
	"text-button": "DS__ConfirmationScreen__text-button",
	"cursor": "DS__ConfirmationScreen__cursor"
};